import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AccessProvider } from './auth/AccessContext.jsx';
import { AuthProvider } from './auth/AuthContext.jsx';
import { DemoProvider, useDemo } from './demo/DemoContext.jsx';
import AppShell from './components/AppShell.jsx';
import Admin from './pages/Admin.jsx';
import Home from './pages/Home.jsx';
import MyTickets from './pages/MyTickets.jsx';
import NewTicket from './pages/NewTicket.jsx';
import Placeholder from './pages/Placeholder.jsx';
import Queue from './pages/Queue.jsx';
import TicketDetail from './pages/TicketDetail.jsx';

/* Emails sent before HD-06 (#57) linked to /tickets/TICK-n, which was never a
 * route. Those emails are already in inboxes, so the old path is sent on to the
 * real one rather than left as "Page not found". New emails use /ticket/. */
function LegacyTicketLink() {
  const { number } = useParams();
  return <Navigate to={`/ticket/${encodeURIComponent(number)}`} replace />;
}

function StaffGate({ admin = false, children }) {
  const { isIT, isAdmin, accessLoading } = useDemo();
  if (accessLoading) return <p className="muted">Loading access?</p>;
  if (!(admin ? isAdmin : isIT)) return <section className="hero"><h1>Access required</h1><p>Ask IT for access through the IHS Hub.</p></section>;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <AccessProvider>
        {/* Reference/profile fixtures remain; staff access uses server rooms. */}
        <DemoProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<AppShell />}>
                <Route index element={<Home />} />
                <Route path="new" element={<NewTicket />} />
                <Route path="mine" element={<MyTickets />} />
                <Route path="ticket/:number" element={<TicketDetail />} />
                <Route path="tickets/:number" element={<LegacyTicketLink />} />
                <Route path="queue" element={<StaffGate><Queue /></StaffGate>} />
                <Route path="admin" element={<StaffGate admin><Admin /></StaffGate>} />
                <Route
                  path="*"
                  element={
                    <Placeholder
                      title="Page not found"
                      note="That link doesn't go anywhere. Use the navigation to get back."
                    />
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </DemoProvider>
      </AccessProvider>
    </AuthProvider>
  );
}
